/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Launch_Stat_New_ToolsInputs */

const en_directory_launch_stat_new_tools = /** @type {(inputs: Directory_Launch_Stat_New_ToolsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} new tools`)
};

const zh_directory_launch_stat_new_tools = /** @type {(inputs: Directory_Launch_Stat_New_ToolsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个新工具`)
};

/**
* | output |
* | --- |
* | "{count} new tools" |
*
* @param {Directory_Launch_Stat_New_ToolsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_stat_new_tools = /** @type {((inputs: Directory_Launch_Stat_New_ToolsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Stat_New_ToolsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_stat_new_tools(inputs)
	return zh_directory_launch_stat_new_tools(inputs)
});
export { directory_launch_stat_new_tools as "directory.launch.stat_new_tools" }